/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

if (document.getElementsByClassName('calendar-container').length > 0) {
  
  document.getElementsByClassName('calendar-container')[0].querySelector('table').setAttribute('role', 'none');
}


/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});
